import { environment } from '../environments/environment';


export namespace Fonts {
    export interface FontType {
        ending?: string;
        format?: string;
        hash?: string;
    }
    export interface Font {
        preload?: boolean;
        url: string;
        types?: string[];
        family: string;
        weight?: number;
        style?: string;
    }


    function mapGoogleFonts(family: string, path: string): Font[] {
        var sizes = {
            "Thin": 100,
            "ExtraLight": 200,
            "Light": 300,
            "Regular": 400,
            "Medium": 500,
            "SemiBold": 600,
            "Bold": 700,
            "ExtraBold": 800,
            "Black": 900,
        };
        const mapUrl = (family: string, path: string, style: string, size: string) => {
            let postfix = '';
            if (style == 'italic')
                postfix = 'Italic';
            if (size == 'Regular' && style == 'italic') {
                return `${path}/${family}-Italic.woff2`
            }
            return `${path}/${family}-${size + postfix}.woff2`
        }
        const mapFont = (family: string, path: string, style: string) => (size: [string, number]) => ({
            preload: size[0] == 'Regular',
            url: mapUrl(family, path, style, size[0]),
            types: ['woff2'],
            family,
            weight: size[1],
            style,
        });
        return Object.entries(sizes).map(mapFont(family, path, 'normal')).concat(Object.entries(sizes).map(mapFont(family, path, 'italic')))
    }

    export function loadFont(fonts: Font[]) {
        try {
            const style = document.createElement('style');

            style.appendChild(document.createTextNode(fonts
                .filter(font => !font?.url?.startsWith('http'))
                .map(font =>
                    `@font-face {
    font-display: swap;
    font-family: ${font.family};
    src: local("${font.family}"),
    local("${font.family.replaceAll('-', ' ')}"),
    url('${new URL(font.url, window?.location?.origin).href}')
    ${font.types[0] != null ? `format(${font.types[0]});` : ';'}
    ${font.weight > 0 ? `font-weight: ${font.weight};` : ''}
    font-style: ${font.style};
}`)
                .join('\n')
            ));
            document.head.appendChild(style);
        } catch (error) { console.error(error); }
        // tslint:disable-next-line: no-string-literal

        const makeFont = (font: Font) => {
            const link = document.createElement('link');
            link.as = 'font';
            const separator = font.url.indexOf('?') === -1 ? '?' : '&';
            link.href = font.url ;
            link.crossOrigin = 'anonymous';
            link.rel = font?.url?.startsWith('http') ? 'stylesheet' : 'preload';
            return link;
        }
        fonts.forEach(font => {
            if (font.preload) {
                if (font?.types?.length > 0) {
                    font?.types?.forEach(type => {
                        const link = makeFont(font);
                        link.type = `font/${type}`;
                        document.head.appendChild(link);
                    });
                }
                else {
                    const link = makeFont(font);

                    document.head.appendChild(link);
                }
            }
        });
        if ('fonts' in document) {
            // tslint:disable-next-line: no-string-literal
            return document['fonts']['ready'];
        }
        return new Promise((resolve) => resolve({}));
    }

    export const preload = mapGoogleFonts("Poppins", "/dist/assets/fonts/Poppins");

}
